import posthog from "posthog-js";
import { isChessbook, isChesscards, isChessmadra } from "./env";
import { setPosthogFeaturesLoaded } from "./experiments";

const POSTHOG_KEY =
	isChessbook || isChessmadra
		? "phc_atElVsO6VniR0N7SppwOvz56DB3pRkkGiL0kRFdKYwu"
		: isChesscards
			? "phc_2MYnsM9F5w0NUjvna9F2cByZQhkrIxPAiH9kJUHSvoW"
			: null;

export const initializePosthog = () => {
	if (!POSTHOG_KEY) {
		return;
	}
	posthog.init(POSTHOG_KEY, {
		api_host: "https://ph.chessbook.com",
		// ui_host: "https://eu.posthog.com",
		autocapture: false,
	});
	posthog.onFeatureFlags(() => {
		setPosthogFeaturesLoaded(true);
	});
};
